import {landingForPath,landingHtml} from './landing-pages';
export const GUIDE_PATH = '/guides/audition-video-checklist';
export const TRUST_PATHS = { privacy: '/privacy', terms: '/terms', support: '/support' } as const;

export interface RouteMetadata {
  title: string;
  description: string;
  canonical: string;
}

const HOME_METADATA: RouteMetadata = {
  title: '보낼연주 — 오디션·콩쿠르 영상 즉시 검사',
  description: '보낼 영상을 먼저 골라 형식·용량·길이·화면 크기를 기기에서 확인하고 공식 요강 제한과 대조하세요.',
  canonical: 'https://bonaelyeonju.com/',
};

const GUIDE_METADATA: RouteMetadata = {
  title: '오디션 연주 영상 제출 체크리스트 7가지 | 보낼연주',
  description: '오디션·콩쿠르 연주 영상 제출 전, 공식 요강에서 파일 형식·용량·길이·편집·파일명·재생·접수 방식을 빠짐없이 확인하세요.',
  canonical: `https://bonaelyeonju.com${GUIDE_PATH}`,
};

const TRUST_METADATA: Record<keyof typeof TRUST_PATHS, RouteMetadata> = {
  privacy: { title: '개인정보 처리방침 | 보낼연주', description: '보낼연주의 로컬 영상 보관, 최소 이용 신호, 삭제와 문의 처리 원칙이에요.', canonical: 'https://bonaelyeonju.com/privacy' },
  terms: { title: '이용약관 | 보낼연주', description: '보낼연주의 서비스 범위, 사용자 책임, 지원처 비공식 도구 경계를 안내해요.', canonical: 'https://bonaelyeonju.com/terms' },
  support: { title: '도움과 문의 | 보낼연주', description: '보낼연주 사용 중 문제를 해결하고 원본 영상 없이 문의하는 방법이에요.', canonical: 'https://bonaelyeonju.com/support' },
};

export function normalizePublicPath(pathname: string): string {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

export function metadataForPath(pathname: string): RouteMetadata {
  const normalized = normalizePublicPath(pathname);
  if(normalized==='/pricing')return {title:'무료 범위와 시즌 패스 | 보낼연주',description:'예정 가격 9,900원 / 180일, 자동 갱신 없음. 현재는 결제 없이 무료로 계속 써요.',canonical:'https://bonaelyeonju.com/pricing'};
  const landing=landingForPath(normalized);
  if(landing&&normalized!==GUIDE_PATH)return {title:landing.title+' | 보낼연주',description:landing.description,canonical:'https://bonaelyeonju.com'+landing.path};
  if (normalized === GUIDE_PATH) return GUIDE_METADATA;
  const trustEntry = (Object.entries(TRUST_PATHS) as [keyof typeof TRUST_PATHS, string][]).find(([, path]) => path === normalized);
  return trustEntry ? TRUST_METADATA[trustEntry[0]] : HOME_METADATA;
}

export function renderRouteMetadata(html: string, pathname: string): string {
  const metadata = metadataForPath(pathname);
  const content=landingHtml(normalizePublicPath(pathname));
  const landing=landingForPath(normalizePublicPath(pathname));
  return html.replace(/<meta property="og:image" content="[^"]*"\s*\/>/,`<meta property="og:image" content="https://bonaelyeonju.com/brand/${landing?.image??'og.png'}" />`).replace('<div id="root"></div>',`<div id="root">${content}</div>`)
    .replace(/<title>[^<]*<\/title>/, `<title>${metadata.title}</title>`)
    .replace(/<meta name="description" content="[^"]*"\s*\/>/, `<meta name="description" content="${metadata.description}" />`)
    .replace(/<meta property="og:title" content="[^"]*"\s*\/>/, `<meta property="og:title" content="${metadata.title}" />`)
    .replace(/<meta property="og:description" content="[^"]*"\s*\/>/, `<meta property="og:description" content="${metadata.description}" />`)
    .replace(/<meta property="og:url" content="[^"]*"\s*\/>/, `<meta property="og:url" content="${metadata.canonical}" />`)
    .replace(/<link rel="canonical" href="[^"]*"\s*\/>/, `<link rel="canonical" href="${metadata.canonical}" />`);
}
